
// gatsby-browser.js
export { wrapRootElement } from './gatsby-ssr';